import { NoveltySelection } from '@/usecases/novelty/novelty-selection'
import { NoveltyEntity } from './selection'

export function convertToUseCaseState(entities: NoveltyEntity[]): NoveltySelection[] {
  return entities.map((entity) => {
    return convertToSingleUseCaseState(entity)
  })
}

export function convertToSingleUseCaseState(entity: NoveltyEntity): NoveltySelection {
  return {
    fkuId: entity.item.fkuId,
    skuId: entity.item.skuId,
    count: entity.state.count,
  }
}
